import { createContext } from "react";

export const AuthContext = createContext({
    username: "",
    setUsername: () => {},
    email: "",
    setEmail: () => {},
    role: "", 
    setRole: () => {},
})